import React from "react";
import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/themes/material_blue.css";

const DatePickerComponent = () => {
  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom pb-2 mb-4">
        Date Picker
      </h1>

      <div className="row">
        
        {/* Select Date */}
        <div className="col-md-6 col-lg-6 col-xl-6">
          <div className="text-left">Select Date</div>

          <Flatpickr
            className="form-control"
            options={{
              dateFormat: "Y-m-d"
            }}
            placeholder="Select date"
          />
        </div>

        {/* Select Date & Time */}
        <div className="col-md-6 col-lg-6 col-xl-6">
          <div className="text-left">Select Date and Time</div>

          <Flatpickr
            className="form-control"
            options={{
              enableTime: true,
              dateFormat: "Y-m-d H:i"
            }}
            placeholder="Select date and time"
          />
        </div>

      </div>
    </div>
  );
};

export default DatePickerComponent;